import { siteStats } from "@/mocks/melonData";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20pop%20art%20collage%20about%20entertainment%20news%20and%20celebrity%20gossip%2C%20camera%20flash%20bursts%2C%20news%20speech%20bubbles%2C%20handheld%20microphone%2C%20play%20and%20pause%20controls%2C%20film%20clapperboard%2C%20warm%20cream%20paper%20texture%20background%20with%20watermelon%20coral%20red%20and%20fresh%20green%20accents%2C%20modern%20editorial%20magazine%20illustration%20style%2C%20no%20text%2C%20clean%20soft%20shapes%2C%20lively%20balanced%20composition&width=1600&height=900&seq=melon-hero-x1&orientation=landscape"
          alt="吃瓜今天 娱乐热点聚合插画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/55 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex min-h-[560px] max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:min-h-[640px] md:px-6 md:py-28">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-background-50/80 px-3.5 py-1.5 text-xs font-semibold text-primary-700">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500"></span>
          已实锤 / 石锤合集 · 每日更新
        </span>

        <h1 className="mt-6 font-heading text-5xl leading-tight tracking-tight text-foreground-950 md:text-7xl">
          吃瓜今天
        </h1>

        <p className="mt-5 max-w-2xl text-base font-medium leading-relaxed text-foreground-700 md:text-lg">
          这里只收录<span className="text-primary-600">已实锤</span>的石头与定论。
          今日合集、实锤名单、落地瓜与盖棺定论清晰列出，
          <br className="hidden md:block" />
          帮你快速分辨哪些热点真正有据可循，不用再猜真假。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#today"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-timer-flash-line"></i>
            看今日已实锤合集
          </a>
          <a
            href="#list"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 bg-background-50/70 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 sm:w-auto"
          >
            <i className="ri-list-check-2"></i>
            打开实锤名单
          </a>
        </div>

        <dl className="mt-12 grid w-full grid-cols-2 gap-3 sm:grid-cols-4 md:max-w-3xl md:gap-4">
          {siteStats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-200 bg-background-50/80 px-4 py-4 text-center backdrop-blur-sm"
            >
              <dd className="font-heading text-3xl text-primary-600 md:text-4xl">
                {s.value}
                <span className="ml-0.5 text-lg text-foreground-500">{s.unit}</span>
              </dd>
              <dt className="mt-1 text-xs font-medium text-foreground-600">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}